export const TONES = {
  // 'A': 75,
  'a': 220,
  // 'S': 150,
  's': 246.942,
  // 'D': 225,
  'd': 261.626,
  // 'F': 300,
  'f': 293.665,
  // 'G': 375,
  'g': 329.628,
  // 'H': 450,
  'h': 349.228,
  // 'I': 525,
  'j': 391.995,
  // 'K': 675,
  'k': 440,
  // 'L': 750,
  'l': 493.883,
  ';': 523.251,
  "'": 587.330,
  'Enter': 659.255
};

export const NOTE_NAMES = [
  // 'A',
  'a',
  // 'S',
  's',
  // 'D',
  'd',
  // 'F',
  'f',
  // 'G',
  'g',
  // 'H',
  'h',
  // 'I',
  // 'J',
  'j',
  // 'K',
  'k',
  // 'L',
  'l',
  ';',
  "'",
  'Enter'
];



/** WEBPACK FOOTER **
 ** ./frontend/util/tones.js
 **/